<template>
  <div :class="positionClass">
    <label class="has-text-black-bis is-italic is-size-3 line-height" v-if="label">
      {{ label }}
    </label>
    <div class="control is-flex-grow-1" v-if="isEditable && !disableInput(rowData) && !rowData.isItemCompleted">
        <span v-if="!$_.isEmpty(selectOptions)">
          <SelectOptions v-if="isBIMPLUS"
            v-model="inputValue"
            :options="selectOptions"
            @update:modelValue="$emit('updateLvlZone', $event)">
          </SelectOptions>
          <mf-multi-select v-else
            v-model="inputValue"
            :placeholder="placeHolder"
            :options="selectOptions"
            :searchable="true"
            :allow-empty="true"
          />
        </span>
         <span v-else>
           <input
              class="input generic-input"
              :type="type"
              v-model="inputValue"
              :placeholder="placeHolder"
              @change="onChange"
            />
        </span>
    </div>
    <div class="is-flex-grow-1" v-else>
    <span>
      {{inputValue}}
    </span>
    </div>
  </div>
</template>
<script>
import { computed, inject, reactive, toRefs } from 'vue';
import { get, isUndefined, isFunction, isEmpty } from 'lodash';
import { useStore } from 'vuex';
import MfMultiSelect from '@/components/abstract/MfMultiSelect.vue';
import ProductionManagerMixin from '@/components/mixins/ProductionManagerMixin';
import SelectOptions from '@/components/abstract/SelectOptions.vue';
import uuid from 'uuid/v4';

export default {
  name: 'LevelOrZoneField',
  components: {
    'mf-multi-select': MfMultiSelect,
    SelectOptions,
  },
  props: [
    'label',
    'value',
    'textValue',
    'type',
    'isEditing',
    'labelPosition',
    'placeHolder',
    'isDisabled',
    'isClickable',
    'eventType',
    'rowField',
    'rowData',
    'isInput',
    'options',
    'projectId',
    'cardId',
    'listView',
    'isBIMPLUS',
  ],
  setup(props, context) {
    const store = useStore();
    const { disableInput } = ProductionManagerMixin();
    const state = reactive({
      positionClass: 'field',
    });
    if (props.labelPosition) {
      switch (props.labelPosition) {
        case 'is-left':
          state.positionClass = 'field is-horizontal';
          break;
        case 'is-right':
          state.positionClass = 'field is-horizontal has-text-right is-pulled-right';
          break;
        case 'is-centered':
          state.positionClass = 'field is-horizontal has-text-centered';
          break;
        default:
          state.positionClass = 'field';
          break;
      }
    }

    const isEditable = computed(() => {
      if (props.rowField?.inputProps && isFunction(props.rowField?.inputProps?.isDisabled)) {
        return !props.rowField?.inputProps?.isDisabled(props.rowData);
      }
      return props.rowField?.inputProps?.isEditing || props.isEditing
      || false;
    });

    const inputValue = computed({
      get: () => {
        const rowValue = get(props, 'value');
        if (rowValue && Array.isArray(rowValue)) return rowValue.toString();
        return rowValue;
      },
      set: (val) => {
        context.emit('update:value', val);
      },
    });

    const selectOptions = computed(() => {
      let opts;
      let inputOpts;
      let BIMPLUSOptions;
      let { projectId } = props;
      if (props?.rowField?.inputProps && props?.rowField?.inputProps?.options) inputOpts = props?.rowField?.inputProps?.options;
      opts = !isEmpty(props.options) ? props.options : inputOpts;
      if (isUndefined(projectId)) {
        projectId = props.rowData?.project?._id || props.rowData?.project;
      }
      const project = store.getters.findProject({ _id: projectId }) || { levels: [], zones: [] };
      if (props.isBIMPLUS) BIMPLUSOptions = get(project, opts, []).map((opt) => { return { name: opt, _id: uuid() }});
      return props.isBIMPLUS ? BIMPLUSOptions : get(project, opts, []);
    });

    return {
      ...toRefs(state),
      inputValue,
      selectOptions,
      isEditable,
      disableInput,
    };
  },
};
</script>
